import { Word } from '@/types/assessmentTypes';

// MODEL2 Assessment Words - 75 words with different vocabulary
export const M2_ASSESSMENT_WORDS: Word[] = [
  // DOMINANCE (15 words) - Leadership and assertiveness
  { id: 1, translationKey: "words.m2.authoritative", category: 'dominance', intensity: 5 },
  { id: 2, translationKey: "words.m2.commanding", category: 'dominance', intensity: 5 },
  { id: 3, translationKey: "words.m2.forceful", category: 'dominance', intensity: 5 },
  { id: 4, translationKey: "words.m2.influential", category: 'dominance', intensity: 5 },
  { id: 5, translationKey: "words.m2.decisive", category: 'dominance', intensity: 5 },
  { id: 6, translationKey: "words.m2.assertive", category: 'dominance', intensity: 4 },
  { id: 7, translationKey: "words.m2.direct", category: 'dominance', intensity: 4 },
  { id: 8, translationKey: "words.m2.firm", category: 'dominance', intensity: 4 },
  { id: 9, translationKey: "words.m2.strongWilled", category: 'dominance', intensity: 4 },
  { id: 10, translationKey: "words.m2.confident", category: 'dominance', intensity: 4 },
  { id: 11, translationKey: "words.m2.ambitious", category: 'dominance', intensity: 3 },
  { id: 12, translationKey: "words.m2.proactive", category: 'dominance', intensity: 3 },
  { id: 13, translationKey: "words.m2.independent", category: 'dominance', intensity: 3 },
  { id: 14, translationKey: "words.m2.selfAssured", category: 'dominance', intensity: 3 },
  { id: 15, translationKey: "words.m2.goalOriented", category: 'dominance', intensity: 3 },

  // EXTRAVERSION (15 words) - Social and communication
  { id: 16, translationKey: "words.m2.expressive", category: 'extraversion', intensity: 5 },
  { id: 17, translationKey: "words.m2.sociable", category: 'extraversion', intensity: 5 },
  { id: 18, translationKey: "words.m2.enthusiastic", category: 'extraversion', intensity: 5 },
  { id: 19, translationKey: "words.m2.vibrant", category: 'extraversion', intensity: 5 },
  { id: 20, translationKey: "words.m2.animated", category: 'extraversion', intensity: 5 },
  { id: 21, translationKey: "words.m2.friendly", category: 'extraversion', intensity: 4 },
  { id: 22, translationKey: "words.m2.warm", category: 'extraversion', intensity: 4 },
  { id: 23, translationKey: "words.m2.engaging", category: 'extraversion', intensity: 4 },
  { id: 24, translationKey: "words.m2.personable", category: 'extraversion', intensity: 4 },
  { id: 25, translationKey: "words.m2.communicative", category: 'extraversion', intensity: 4 },
  { id: 26, translationKey: "words.m2.approachable", category: 'extraversion', intensity: 3 },
  { id: 27, translationKey: "words.m2.welcoming", category: 'extraversion', intensity: 3 },
  { id: 28, translationKey: "words.m2.interactive", category: 'extraversion', intensity: 3 },
  { id: 29, translationKey: "words.m2.affable", category: 'extraversion', intensity: 3 },
  { id: 30, translationKey: "words.m2.gregarious", category: 'extraversion', intensity: 3 },

  // PATIENCE (15 words) - Calm and steady
  { id: 31, translationKey: "words.m2.composed", category: 'patience', intensity: 5 },
  { id: 32, translationKey: "words.m2.tranquil", category: 'patience', intensity: 5 },
  { id: 33, translationKey: "words.m2.steady", category: 'patience', intensity: 5 },
  { id: 34, translationKey: "words.m2.unflappable", category: 'patience', intensity: 5 },
  { id: 35, translationKey: "words.m2.poised", category: 'patience', intensity: 5 },
  { id: 36, translationKey: "words.m2.gentle", category: 'patience', intensity: 4 },
  { id: 37, translationKey: "words.m2.balanced", category: 'patience', intensity: 4 },
  { id: 38, translationKey: "words.m2.evenTempered", category: 'patience', intensity: 4 },
  { id: 39, translationKey: "words.m2.accommodating", category: 'patience', intensity: 4 },
  { id: 40, translationKey: "words.m2.flexible", category: 'patience', intensity: 4 },
  { id: 41, translationKey: "words.m2.thoughtful", category: 'patience', intensity: 3 },
  { id: 42, translationKey: "words.m2.considerate", category: 'patience', intensity: 3 },
  { id: 43, translationKey: "words.m2.understanding", category: 'patience', intensity: 3 },
  { id: 44, translationKey: "words.m2.peaceful", category: 'patience', intensity: 3 },
  { id: 45, translationKey: "words.m2.supportive", category: 'patience', intensity: 3 },

  // FORMALITY (15 words) - Structure and order
  { id: 46, translationKey: "words.m2.organized", category: 'formality', intensity: 5 },
  { id: 47, translationKey: "words.m2.systematic", category: 'formality', intensity: 5 },
  { id: 48, translationKey: "words.m2.structured", category: 'formality', intensity: 5 },
  { id: 49, translationKey: "words.m2.methodical", category: 'formality', intensity: 5 },
  { id: 50, translationKey: "words.m2.rigorous", category: 'formality', intensity: 5 },
  { id: 51, translationKey: "words.m2.procedural", category: 'formality', intensity: 4 },
  { id: 52, translationKey: "words.m2.detailed", category: 'formality', intensity: 4 },
  { id: 53, translationKey: "words.m2.thorough", category: 'formality', intensity: 4 },
  { id: 54, translationKey: "words.m2.careful", category: 'formality', intensity: 4 },
  { id: 55, translationKey: "words.m2.precise", category: 'formality', intensity: 4 },
  { id: 56, translationKey: "words.m2.professional", category: 'formality', intensity: 3 },
  { id: 57, translationKey: "words.m2.proper", category: 'formality', intensity: 3 },
  { id: 58, translationKey: "words.m2.conventional", category: 'formality', intensity: 3 },
  { id: 59, translationKey: "words.m2.traditional", category: 'formality', intensity: 3 },
  { id: 60, translationKey: "words.m2.orderly", category: 'formality', intensity: 3 },

  // OBJECTIVITY (15 words) - Analytical thinking
  { id: 61, translationKey: "words.m2.dataDriven", category: 'objectivity', intensity: 5 },
  { id: 62, translationKey: "words.m2.reasoned", category: 'objectivity', intensity: 5 },
  { id: 63, translationKey: "words.m2.impartial", category: 'objectivity', intensity: 5 },
  { id: 64, translationKey: "words.m2.evidenceBased", category: 'objectivity', intensity: 4 },
  { id: 65, translationKey: "words.m2.cerebral", category: 'objectivity', intensity: 4 },
  { id: 66, translationKey: "words.m2.calculated", category: 'objectivity', intensity: 4 },
  { id: 67, translationKey: "words.m2.rationalMinded", category: 'objectivity', intensity: 3 },
  { id: 68, translationKey: "words.m2.factFocused", category: 'objectivity', intensity: 3 },
  { id: 69, translationKey: "words.m2.measured", category: 'objectivity', intensity: 3 },
  { id: 70, translationKey: "words.m2.reflective", category: 'objectivity', intensity: 2 },
  { id: 71, translationKey: "words.m2.perceptive", category: 'objectivity', intensity: 2 },
  { id: 72, translationKey: "words.m2.feelingOriented", category: 'objectivity', intensity: 1 },
  { id: 73, translationKey: "words.m2.passionate", category: 'objectivity', intensity: 1 },
  { id: 74, translationKey: "words.m2.instinctive", category: 'objectivity', intensity: 1 },
  { id: 75, translationKey: "words.m2.sentimental", category: 'objectivity', intensity: 1 },
];

export default M2_ASSESSMENT_WORDS;
